/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {NamedLogger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {gsap} from "gsap";

export class ExorcismSound {

    public static INTRO_MUSIC:string = "";
    public static FS_INTRO:string = "";
    public static FREESPINS_MUSIC:string = "fsLoop";
    public static SUPER_FREESPINS_MUSIC:string = "fsLoop";
    public static BASE_GAME_MUSIC:string = "background-music-main";

    private _currentMusic:string;
    private player:NolimitAudioPlayer;
    private logger:NamedLogger;

    private countUpLoop:NolimitHowl | undefined;

    private freespinsOutroLoop:NolimitHowl | undefined;



    private _previousSound: string;
    private _stopRepeatSoundTL: gsap.core.Timeline;
    private _stopRepeatSound: boolean;

    //private davidPanningReelStop: number[] = [-0.14, -0.07, 0.0, 0.07, 0.14];
    private davidPanningReelStop: number[] = [-0.5, -0.2, 0.0, 0.2, 0.5];

    public static get soundPlayer(): NolimitAudioPlayer {
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    constructor() {
        this.player = <NolimitAudioPlayer>SlotGame.sound;
        this.logger = new NamedLogger("DCSound");

        this._stopRepeatSoundTL = gsap.timeline();
        this._stopRepeatSoundTL.add((): void => {
            this._previousSound = "";
            this._stopRepeatSound = false;
        }, "+=0.1");
    }


    private static createConfig(name:string, volume?:number, fVolume?:number, repeat?:number, fadeDur?:number) {
        return {
            name:name,
            volume:volume,
            fVolume:fVolume,
            repeat:repeat,
            fadeDurr:fadeDur
        }
    }

    public playLoopingSound(name:string, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number):void {
        this.playAndGetLoopingSound(name, volume, fadeVolume, repeat, fadeDuration);
    }

    public playAndGetLoopingSound(name:string, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number):NolimitHowl | undefined {
        const sound = this.playAndGetSound(name, volume, fadeVolume, repeat, fadeDuration);
        if (sound) {
            sound.setLoop(true);
        }
        return sound;
    }

    public playSound(name:string, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number):void {
        this.playAndGetSound(name, volume, fadeVolume, repeat, fadeDuration);
    }

    public playSoundWithDavidPanning(soundName:string, reelID:number, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number) {
        const sound:NolimitHowl|undefined = this.playAndGetSound(soundName, volume, fadeVolume, repeat, fadeDuration);
        //Logger.logDev("Sound: Play Track: ", soundName);

        if(sound) {
            sound.player.stereo(this.davidPanningReelStop[reelID]);
        }
    }

    public playSoundNoOverlap(name:string, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number):void {
        if (this._previousSound == name && this._stopRepeatSound == true) {
            return;
        } else {
            this._previousSound = name;
            this._stopRepeatSound = true;
            this._stopRepeatSoundTL.restart();
            //logger.logDev("------- Play sound: " + name);
            //return this._player.playTrack({name: name, volume: volume, repeat: repeat});
            this.playSound(name, volume, fadeVolume, repeat, fadeDuration);
        }
    }
    public playSoundNoOverlapDavidPanning(name:string, reelID:number, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number):void {
        if (this._previousSound == name && this._stopRepeatSound == true) {
            return;
        } else {
            this._previousSound = name;
            this._stopRepeatSound = true;
            this._stopRepeatSoundTL.restart();
            //logger.logDev("------- Play sound: " + name);
            //return this._player.playTrack({name: name, volume: volume, repeat: repeat});
            this.playSoundWithDavidPanning(name, reelID, volume, fadeVolume, repeat, fadeDuration);
        }
    }

    public playAndGetSound(name:string, volume?:number, fadeVolume?:number, repeat?:number, fadeDuration?:number):NolimitHowl | undefined {
        this.logger.log("playSound: " + name);
        return this.player.playTrack(ExorcismSound.createConfig(name, volume, fadeVolume, repeat, fadeDuration));
    }

    public stopSound(name:string, fadeOutMS:number = 0) {
        if (fadeOutMS > 0) {
            const tl = gsap.timeline();
            tl.add(() => {
                this.player.fadeTrack({name:name, to:0, duration:fadeOutMS})
            });
            tl.add(() => {
                this.player.stopTrack(name)
            }, fadeOutMS * 0.001);

        } else {
            this.player.stopTrack(name);
        }
    }

    public isSoundPlaying(name:string):boolean {
        const player = this.player.fetchSoundPlayer(name);
        if(!player)
            return false;
        else
            return player.isPlaying;
    }

    public restartMusic() {
        if(!this._currentMusic)
            return;

        this.player.stopTrack(this._currentMusic);
        this.player.playTrack(ExorcismSound.createConfig(this._currentMusic, 1, undefined));
    }

    public switchMusic(mode:GameMode | string) {
        let nextMusic = "";

        switch (mode) {
            case "INTRO":
                nextMusic = ExorcismSound.INTRO_MUSIC;
                break;
            case "FS_INTRO":
                nextMusic = ExorcismSound.FS_INTRO;
                break;
            case "FS_OUTRO":
                nextMusic = ExorcismSound.FS_INTRO;
                break;
            case GameMode.FREESPIN:
                nextMusic = ExorcismSound.FREESPINS_MUSIC;
                break;
            case GameMode.FREESPIN_SUPER:
                nextMusic = ExorcismSound.SUPER_FREESPINS_MUSIC;
                break;
            default:
                nextMusic = ExorcismSound.BASE_GAME_MUSIC;
                break;
        }

        if (nextMusic == this._currentMusic) {
            return;
        }

        if (this._currentMusic) {
            this.player.stopTrack(this._currentMusic);
        }

        this.player.playTrack(ExorcismSound.createConfig(nextMusic, 1, undefined));
        this._currentMusic = nextMusic;
    }

    public fadeOutMusic(duration:number = 300, targetVolume:number = 0) {
        if (this._currentMusic) {
            this.player.fadeTrack({
                name:this._currentMusic,
                to:targetVolume,
                duration:duration
            });
        }
    }

    public fadeInMusic(duration:number = 300) {
        if (this._currentMusic) {
            this.player.fadeTrack({
                name:this._currentMusic,
                to:1,
                duration:duration
            });
        }
    }

}